import styled from 'styled-components';

export default styled.div`
.filters {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & > * {
        margin: 0px;
        margin-right: 10px;
    }
    
    .textField {
        // Overriding margin, because it enlarges this item and 
        // it doesn't align well with other flex items (vertically) 
        margin-bottom: 0;
    }
}
`;
